var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadAttachment2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58398 13.6667C1.25065 13.6667 0.958984 13.5417 0.708984 13.2917C0.458984 13.0417 0.333984 12.75 0.333984 12.4167V9.43754H1.58398V12.4167H12.4173V9.43754H13.6673V12.4167C13.6673 12.75 13.5423 13.0417 13.2923 13.2917C13.0423 13.5417 12.7507 13.6667 12.4173 13.6667H1.58398ZM7.00065 10.4792L2.97982 6.45837L3.87565 5.56254L6.37565 8.06254V0.333374H7.62565V8.06254L10.1257 5.56254L11.0215 6.45837L7.00065 10.4792Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAttachment2);
export default __webpack_public_path__ + "static/media/download-attachment2.088557cd536d18048d5c915a3f2b7d2f.svg";
export { ForwardRef as ReactComponent };